// extracted by mini-css-extract-plugin
export var productContent = "product-content-module--product-content--owLat";
export var productContent_reversed = "product-content-module--product-content_reversed--tdbHa";
export var productContent__featureItem = "product-content-module--product-content__feature-item--NspNX";
export var productContent__media = "product-content-module--product-content__media--J3cVK";
export var productContent__mobileApps = "product-content-module--product-content__mobile-apps--JEXYB";
export var productContent__mobileAppsLink = "product-content-module--product-content__mobile-apps-link--2z9d8";